import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserContextService } from '../../../auth-management/authentication/services/user-context.service';
import { IAssignSpecializedRolesPermissionsRequest } from '../dtos/requests/assign-specialized-roles-permissions-request';
import { IRevokeSpecializedRolesPermissionsRequest } from '../dtos/requests/revoke-specialized-roles-permissions-request';
import { userManagementUrl } from '../../../../../constants';
import { SpecializedRolesPermissionItem } from '../dtos/responses/specialized-roles-permissions-list-response';
import { IRequestOptions } from '../../../../core/data-access/http-client/models/request-options.model';
import { permissionGroupsTestData } from '../../../permission-management/permission-groups/data/permission-groups.data';
import { IPermissionGroup } from '../../../permission-management/permission-groups/models/permission-group.model';
import { Logger } from '../../../../core';

@Injectable({
  providedIn: 'root'
})
export class SpecializedRolesApiClientService {
  collectionUrl: string = `${userManagementUrl}/accounts/${
    UserContextService.getUserContext()?.accountId
  }/specialized-roles`;

  constructor(protected http: HttpClient) {}

  // getPermissionsById(id: any, options: IRequestOptions | undefined = undefined): Observable<SpecializedRolesPermissionItem> {
  //   return this.http.get<SpecializedRolesPermissionItem>(`${this.collectionUrl}/${id}/permissions`, options);
  // }
  // getPermissionsById(id: any): Observable<IPermissionGroup[]> {
  //   return this.http.get<IPermissionGroup[]>(`${this.collectionUrl}/${id}/permissions`, options);
  // }

  // assignPermission(request: IAssignSpecializedRolesPermissionsRequest, id: number | string): Observable<any> {
  //   return this.http.post<any>(`${this.collectionUrl}/${id}/permissions`, request);
  // }

  // revokePermission(request: IRevokeSpecializedRolesPermissionsRequest, id: number | string): Observable<any> {
  //   return this.http.delete<any>(`${this.collectionUrl}/${id}/permissions`, { body: request });
  // }

  // Using fake permission groups data
  getPermissionsById(id: any): Observable<IPermissionGroup[]> {
    return of(permissionGroupsTestData);
  }

  assignPermission(request: IAssignSpecializedRolesPermissionsRequest, id: number | string): Observable<any> {
    Logger.debug('assignPermission called with:', request);
    return of({ success: true });
  }

  revokePermission(request: IRevokeSpecializedRolesPermissionsRequest, id: number | string): Observable<any> {
    Logger.debug('revokePermission called with:', request);
    return of({ success: true });
  }
}
